import React from 'react'
import styles from "./byaptism_of_fire.module.css";
import Image from 'next/image';
import MysteryBannerNew from '../../components/MysteryBannerNew/MysteryBannerNew';

export default function Byaptism_of_fire() {
    return (
        <>

            <div className={styles.byaptism_of_fire_main_wrapper}>
                <div className={styles.byaptism_of_fire_block_1}>
                    <div className={styles.byaptism_of_fire_banner_main_wrpr}>
                        <div className={styles.byaptism_of_fire_banner_left}>
                            <div className={styles.bannerLogo}>
                                <span className={styles.logoviewlink} >
                                    <Image
                                        src="/image/viewicon.webp"
                                        alt="View Icon"
                                        width={400}
                                        height={100}
                                        style={{ width: "100%", height: "auto" }}
                                        priority={true}
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                    />
                                </span>
                                <Image
                                    src="/image/logobanner_cropped.webp"
                                    alt="School of Our Divine Infinite Being Logo"
                                    width={332}
                                    height={332}
                                    style={{ width: "100%", height: "auto" }}
                                    priority={true}
                                    placeholder="blur"
                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                />
                            </div>
                            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
                            <h1 data-text="infinite being">INFINITE BEING</h1>

                            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
                            <div
                                className={`${styles.byaptism_of_fire_bottombannerbg} ${styles.bannerboxtxt}`}
                            >
                                <div className={styles.yellow_bar}></div>
                            </div>
                        </div>
                    </div>
                </div>

                <MysteryBannerNew/>

                <div className={styles.byaptism_of_fire_body_wrapper}>

                    <div className={styles.byaptism_of_fire_block_heading}>
                        <div className={styles.common_width}>
                            <div className={` ${styles.titleblock}`}>
                                <div className={styles.column}>
                                    <div className={` ${styles.bgifive}`}>
                                        <h1>Baptism by Fire and Water
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className={`${styles.byaptism_of_fire_block}`}>
                        <div className={styles.common_width}>

                            {/* ----------------------sub-block----------------------------------- */}

                            <div className={`${styles.byaptism_of_fire_block_1_sub} ${styles.byaptism_of_fire_flx_wrpr} ${styles.common_byaptism_of_fire_block}`}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk1_img.webp" width={1761} height={1664} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr} ${styles.font45} ${styles.bold_white} ${styles.border_btm_yellow} ${styles.font35}`}>

                                        <h2>A Living Sacrament of Alignment</h2>

                                        <p>Within the <span>School of our Divine Infinite Being</span>, baptism is a <span>living sacrament of alignment</span>—a deliberate crossing from aspiration into <span>vow</span>, from interest into <span>belonging</span>, from study into <span>embodied devotion</span>. By baptism, the seeker consents to be <span>seen, sealed, and sent</span>: seen by heaven, sealed by sacrament, and sent to serve.
                                        </p>

                                        <p>Baptism is offered both to those who enter the <span>Perennial Mandalan Faith</span> and to those who cross the threshold into our <span>Inner Mystery School</span>. While these streams are distinct in emphasis, they share one current: to bind a human life to the radiance of heaven and the tenderness of earth, to walk <span>in power and in love</span>, and to live in a community that remembers the soul.
                                        </p>

                                        <p>We hold forth two complementary seals, each bearing its own cosmic mark, each opening its gate of transformation:
                                        </p>

                                        <h3>The way of the Sun - The way of the Earth</h3>

                                        <div className={styles.colored_flx_wrpr}>
                                           <div className={`${styles.wtr_fire_block} ${styles.bg_orng}`}>
                                               <h4>By Fire</h4>
                                               <h5>the baptism of the Sun, consecrated to Sūrya–Nārāyaṇa as Krishna, the radiant charioteer of worlds that dwells at the center of the Zodiac. This is the seal of 
                                               illumination and will, the rite of theurgists and seekers of divine intelligence.</h5>
                                           </div>

                                           <div className={`${styles.wtr_fire_block} ${styles.bg_blue}`}>
                                                <h4>By Water</h4>
                                               <h5>the baptism of the living waters, where Earth is transfigured by Light. It is 
                                               consecrated to Christ dwelling upon the earth, and it enfolds the initiate into the communion of love, devotion, and fellowship within the radiant spiritual world of Krishna in Goloka Vṛndāvana—heaven on earth, the eternal abode of divine companionship.</h5>

                                           </div>
                                       </div>

                                        <p>Together they create a whole consecration—<span>Spirit and Form, Sun and Earth, Krishna and Christ</span>—crowning the soul with radiance and rooting it in fellowship.</p>
                                    </div>
                                </div>

                            </div>

                            <div className={`${styles.byaptism_of_fire_block_2_sub} ${styles.byaptism_of_fire_flx_wrpr} ${styles.flx_reverse} ${styles.common_byaptism_of_fire_block} ${styles.font40} ${styles.bold_skyblue}`}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk2_img.webp" width={1850} height={1493} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr}`}>

                                        <h2>I. Theology & Symbol: Why Fire? Why Water?</h2>

                                        <p><span>Fire</span> is the grammar of illumination. In our tradition it is the signature of <span>will aligned to the Divine</span>, the clear flame of noonday that casts out confusion. Fire is intelligence, order, clarity, and
                                            courage. To be baptized by Fire is to be sealed to the Solar Current of Sūrya–Nārāyaṇa—Krishna enthroned in the orb of the Sun, who turns the zodiacal wheel <span>(rāśi–cakra)</span> and sustains the law of becoming. This seal belongs especially to those walking the path of theurgy and ritual praxis.
                                        </p>

                                        <p>Water is the grammar of embodiment and communion. It carries the mercy that binds community and the tenderness by which spirit becomes flesh without losing its brightness. Water is belonging, compassion, renewal, and joy. To be baptized by Water is to be received into the body of Christ upon the earth, entering the living fellowship of Goloka Vṛndāvana—the eternal world of divine love made present here and now. This seal belongs especially to those called to <span>pastoral care, devotion, and the building of spiritual family</span>.</p>

                                        <p><span>Together:</span> Fire crowns; Water roots. Fire orders; Water cherishes. Fire commits the hands; Water keeps the heart. A soul may receive either seal in integrity; many are led to receive both over time.</p>
                                    </div>
                                </div>

                            </div>

                            <div className={`${styles.byaptism_of_fire_block_3_sub} ${styles.byaptism_of_fire_flx_wrpr} ${styles.common_byaptism_of_fire_block}`}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk3_img.webp" width={1761} height={1664} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr} ${styles.font40} ${styles.bold_skyblue} `}>

                                        <h2>II. Baptism by Fire — The Baptism of the Sun
                                        </h2>

                                        <p><span>Designation:</span> The Solar Baptism of Sūrya–Nārāyaṇa, Krishna the Eternal Charioteer
                                        </p>

                                        <div className={`${styles.pink_wrpr} ${styles.bullet_lrg_txt} ${styles.byaptism_bullet_wrpr}`}>

                                            <h3>1) What the Fire Rite Confers</h3>

                                            <div className={`${styles.byaptism_bullet_wrpr_innr} ${styles.white_bullet}`}>
                                                <p>Alignment to the Solar Axis: a vow to stand upright in the Sun’s clarity, cultivating
                                                    truth, steadiness, and disciplined will.</p>
                                                <p>
                                                    Seal of Theurgy: the empowerment to engage consciously with planetary and zodiacal currents, entering the School’s ritual grammar as a living participant.</p>
                                                <p>Consecration to the Inner Light: a pledge to honor the radiance within, guided by the Solar Zodiac, and to manifest strength as blessing, wisdom as uplift, and will as harmony with the celestial order.</p>
                                            </div>

                                        </div>

                                        <div className={`${styles.gredient_orng_wrpr} ${styles.bullet_lrg_txt} ${styles.byaptism_bullet_wrpr}`}>

                                            <h3>2) Where & How It Is Performed</h3>

                                            <div className={`${styles.byaptism_bullet_wrpr_innr} ${styles.white_bullet}`}>
                                                <p>In person at our central temple in Idaho (preferred when possible).</p>
                                                <p>Remotely via Zoom, with the full ritual form adapted for distance; space and time are no barrier to the Solar Current.</p>
                                                <p>The rite may be performed by any consecrated Priest or Priestess of the Order,
                                                    ensuring that baptism is available wherever the lineage is carried.</p>
                                            </div>

                                        </div>
                                        <div className={`${styles.gredient_yellow_wrpr} ${styles.bullet_lrg_txt} ${styles.byaptism_bullet_wrpr}`}>
                                            <h3>3) Preparation (7–10 days)</h3>

                                            <div className={`${styles.byaptism_bullet_wrpr_innr} ${styles.black_bullet}`}>
                                                <p>Fasting/Abstinence (optional but recommended): choose a simple dietary discipline or abstain from one habit to sharpen intention.</p>
                                                <p>Daily Raja Yoga (10 minutes): still the interior and quicken clarity. This can be
                                                    combined with any additional yoga or theurgy.</p>
                                                <p>Solar Contemplation: brief visualization of the Sun at the heart daily in preparation; write and recite a short prayer to Sūrya–Nārāyaṇa.</p>
                                                <p>Journaling (optional but recommended): “What must the fire in me burn away? What must it make bright?”</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className={`${styles.byaptism_of_fire_block_4_sub} ${styles.byaptism_of_fire_flx_wrpr} ${styles.flx_reverse} ${styles.common_byaptism_of_fire_block} ${styles.font40} ${styles.bold_skyblue}`}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk4_img.webp" width={1850} height={1493} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr} ${styles.ocean_color} ${styles.txt_35} ${styles.txt_30}`}>

                                        <h3>4) Rite Shape (Condensed Outline)</h3>

                                        <div className={styles.ocean_bullet_wrpr}>
                                            <p>Invocation of Our Divine Infinite Being: the priest/priestess establishes the higher axis of presence</p>
                                            <p>Invocation of Sūrya–Nārāyaṇa: the Solar Lord is called forth as eternal charioteer of the zodiac.
                                            </p>
                                            <p>Invocation of the Aspirant’s Solar Sign: the priest/priestess, having studied the natal chart of the candidate, invokes the Sun sign under which they were born, calling its daemonic power to witness.</p>
                                            <p>Specialized Prayer: prepared in advance by the officiant from the aspirant’s natal chart, this prayer names their unique solar destiny and binds it to the living current of the Order.</p>
                                            <p>Presentation of the Candidate: the aspirant speaks their name, intention, and vow before heaven and community.</p>
                                            <p>Sealing with Fire: the priest/priestess anoints the brow and heart, and traces the glyph of the Sun sign upon the crown, sealing the aspirant to the Solar Current.</p>
                                            <p>Charge & Blessing: a spoken commissioning is given, followed by the community’s
                                                response.</p>
                                        </div>

                                        <h4>The rite is witnessed by at least one other person.</h4>

                                        <div className={styles.deep_olive_green_wrpr}>

                                            <div className={styles.call_response_wrpr}>
                                                <h5>Liturgical Excerpt (Call & Response):</h5>
                                            </div>

                                            <div className={styles.call_response_bullet_wrpr}>
                                                <p><span>Officiant:</span> Who comes to the Sun?</p>
                                                <p><span>Candidate:</span> I come to the Sun.</p>
                                                <p><span>Officiant:</span> Who seeks the light that orders all things?</p>
                                                <p><span>Candidate:</span> I seek the light and I will keep it.</p>
                                                <p><span>Officiant:</span> Sūrya–Nārāyaṇa, Eternal Charioteer, look upon this soul and seal
                                                    them with your radiance.</p>
                                                <p><span>Community:</span> So let it be.</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className={`${styles.byaptism_of_fire_block_5_sub} ${styles.byaptism_of_fire_flx_wrpr} ${styles.common_byaptism_of_fire_block} `}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk5_img.webp" width={1761} height={1664} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr} ${styles.font40} ${styles.bold_skyblue} ${styles.font35}`}>

                                        <h2>III. Baptism by Water — The Baptism of the Earthly Christ
                                        </h2>

                                        <p><span>Designation:</span> The Living Waters of Christ in Goloka Vṛndāvana

                                        </p>

                                        <div className={`${styles.pink_wrpr} ${styles.bullet_lrg_txt} ${styles.byaptism_bullet_wrpr}`}>

                                            <h3>1) What the Fire Rite Confers</h3>

                                            <div className={`${styles.byaptism_bullet_wrpr_innr} ${styles.white_bullet}`}>
                                                <p>Seal of Compassion: a vow to embody mercy, forgiveness, and gentleness, living as a child of the Light in fellowship with others.</p>
                                                <p>Entrance into Goloka Vṛndāvana: initiation into the spiritual community of love and
                                                    devotion—heaven on earth revealed in the heart.
                                                </p>
                                                <p>
                                                    Consecration to Fellowship: a pledge to walk not alone but in communion, joining one’s life to the body of Christ and the shared joy of the faithful.</p>
                                            </div>

                                        </div>

                                        <div className={`${styles.gredient_orng_wrpr} ${styles.bullet_lrg_txt} ${styles.byaptism_bullet_wrpr}`}>

                                            <h3>2) Where & How It Is Performed</h3>

                                            <div className={`${styles.byaptism_bullet_wrpr_innr} ${styles.white_bullet}`}>
                                                <p>In person in the flowing waters of the Snake River in Idaho (preferred when possible, especially in summer).
                                                </p>
                                                <p>
                                                    At satellite gatherings beyond our central home, when a sacred body of water is
                                                    accessible.
                                                </p>
                                                <p>
                                                    Adapted rites may be performed by pouring or sprinkling when immersion is not
                                                    possible.</p>
                                                <p>
                                                    The rite may be performed by any consecrated Priest or Priestess of the Order,
                                                    ensuring baptism is available wherever the lineage is carried.
                                                </p>
                                            </div>

                                        </div>
                                        <div className={`${styles.gredient_yellow_wrpr} ${styles.bullet_lrg_txt} ${styles.byaptism_bullet_wrpr}`}>
                                            <h3>3) Preparation (7–10 days)</h3>

                                            <div className={`${styles.byaptism_bullet_wrpr_innr} ${styles.black_bullet}`}>
                                                <p>Offering: bring a small gift of bread, fruit, or flowers to share in fellowship
                                                    after the rite.
                                                </p>
                                                <p>Practice of Mercy: complete one intentional act of reconciliation, kindness, or
                                                    generosity.
                                                </p>
                                                <p>
                                                    Contemplation: meditate daily on the image of Christ dwelling upon the earth,
                                                    shining through the waters of life.
                                                </p>
                                                <p>
                                                    Journaling (optional but recommended): “What must the waters wash away in me? What new life am I ready to welcome?”</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className={`${styles.byaptism_of_fire_block_6_sub} ${styles.byaptism_of_fire_flx_wrpr} ${styles.flx_reverse} ${styles.common_byaptism_of_fire_block} ${styles.font40} ${styles.bold_skyblue}`}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk6_img.webp" width={1850} height={1493} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr} ${styles.ocean_color} ${styles.txt_35} ${styles.txt_30}`}>

                                        <h3>4) Rite Shape (Condensed Outline)</h3>

                                        <div className={styles.ocean_bullet_wrpr}>
                                            <p>Invocation of Our Divine Infinite Being: the priest/priestess establishes the higher
                                                axis of presence.</p>
                                            <p>Invocation of Christ the Light: the indwelling Christ is called as the living presence who sanctifies the living waters of the earth.

                                            </p>
                                            <p>
                                                Invocation of Goloka Vṛndāvana: the eternal abode of love is invoked as the spiritual fellowship into which the candidate is received.</p>
                                            <p>
                                                Specialized Prayer: prepared in advance by the officiant, naming the aspirant’s path of compassion and their entrance into community.</p>
                                            <p>Presentation of the Candidate: the aspirant speaks their name, intention, and vow before heaven and community.</p>
                                            <p>Immersion in Water: the aspirant is gently lowered into the living waters and lifted again, or has the waters poured upon them in threefold blessing, sealing them to the fellowship of the Light.</p>
                                            <p>Charge & Blessing: a spoken commissioning is given, followed by the community’s response.</p>
                                        </div>

                                        <h4>The rite is witnessed by at least one other person.</h4>

                                        <div className={styles.deep_olive_green_wrpr}>

                                            <div className={styles.call_response_wrpr}>
                                                <h5>Liturgical Excerpt (Call & Response):</h5>
                                            </div>

                                            <div className={styles.call_response_bullet_wrpr}>
                                                <p><span>Officiant:</span> Who comes to the Waters?</p>
                                                <p><span>Candidate:</span> I come to the Living Waters of Christ.</p>
                                                <p><span>Officiant:</span> Who seeks the light that dwells upon the earth?
                                                </p>
                                                <p><span>Candidate:</span>  I seek the fellowship of love, and I will keep it.
                                                </p>
                                                <p><span>Officiant:</span> Christ of the Living Earth, receive this soul into Goloka Vṛndāvana—heaven
                                                    on earth, the eternal garden of divine love.</p>
                                                <p><span>Community:</span>  So let it be.</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className={`${styles.byaptism_of_fire_block_7_sub} ${styles.byaptism_of_fire_flx_wrpr}  ${styles.common_byaptism_of_fire_block} `}>

                                <div className={styles.byaptism_of_fire_img_box_wrpr}>

                                    <Image alt='' src="/image/byaptism-of-fire/baptism_blk7_img.webp" width={1850} height={1493} />

                                </div>

                                <div className={styles.byaptism_of_fire_txt_box_wrpr}>
                                    <div className={`${styles.byaptism_of_fire_txt_box_innr} ${styles.font45} ${styles.bold_white} ${styles.border_btm_yellow}`}>

                                        <h2>Scheduling Your Baptism</h2>

                                        <p>Applications for <span>Baptism by Fire</span> and <span>Baptism by Water</span> are made through the <span>School of our Divine Infinite Being Backoffice</span>. There you may request your rite, indicate whether you will attend in person or remotely, and be connected with a consecrated Priest or Priestess who will guide your preparation.
                                        </p>

                                        <p>Once your application is received, you will be contacted with instructions, dates, and any 
                                        additional details needed for your baptism.</p>

                                        
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
